import * as types from "./actions";
import { MAX_10_DIGITS, MAX_11_DIGITS, ORDERPATTERN_CODE } from "../../../../utils/constants";

const defaultState = {
    list: [],
    tableHeader: [
        {
            label: "パターンコード",
            button: false,
            rightAlign: true,
            headerClass: "header-id-medium",
        },
        {
            label: "パターン名",
            button: false,
            headerClass: "min-width-200"
        },
        {
            label: "最小注文数",
            button: false,
            rightAlign: true
        },
        {
            label: "最大注文数",
            button: false,
            rightAlign: true
        },
        {
            label: "倍数",
            button: false,
            rightAlign: true
        },
        {
            label: "編集",
            button: true
        },
        {
            label: "コピー",
            button: true
        }
    ],
    tableColumns: [
        "controlPatternCode",
        "controlPatternName",
        "minVal",
        "maxVal",
        "multiVal"
    ],
    form: [
        {
            type: "number",
            label: "パターンコード",
            placeholder: "",
            min: 0,
            max: MAX_11_DIGITS,
            name: "controlPatternCode",
            disabled: false,
            readOnly: true,
            required: true
        },
        {
            type: "text",
            label: "パターン名",
            placeholder: "",
            minLength: 1,
            maxLength: 40,
            name: "controlPatternName",
            disabled: false,
            required: true,
            hasDefault:true,
        },
        {
            type: "number",
            label: "最小注文数",
            placeholder: "",
            max: MAX_10_DIGITS,
            name: "minVal",
            disabled: false,
            hasDefault:true,
        },
        {
            type: "number",
            label: "最大注文数",
            placeholder: "",
            max: MAX_10_DIGITS,
            name: "maxVal",
            disabled: false,
            hasDefault:true,
        },
        {
            type: "number",
            label: "倍数",
            placeholder: "",
            max: MAX_10_DIGITS,
            name: "multiVal", 
            disabled: false,
            required: true,
            hasDefault:true,
        }
    ],
    select: []
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.LIST:
            let patterns = [];
            action.payload.map(item => patterns.push({ name: ORDERPATTERN_CODE, label: "["+item.controlPatternCode+"]"+ item.controlPatternName, value: item.controlPatternCode }));
            return { ...state, list: action.payload, select: patterns };
        default:
            return state;
    }
};
